<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" sm="1">
        <router-link
          :to="{ name: 'OverviewPage', hash: '#insurance' }"
          class="back-arrow"
          ><v-icon large color="mid-grey" class="mt-1">{{
            icons.mdiArrowLeft
          }}</v-icon></router-link
        >
      </v-col>
      <v-col cols="12" sm="11" class="insurance-explanation-container">
        <h1 class="title-text">
          Protect Your Loved Ones from Unexpected Financial Stress
        </h1>

        <div class="header-with-paragraph">
          <h3>
            No matter who you are, there will be costs associated with your
            death.
          </h3>
          <p>
            Unexpected legal and administrative costs can burden your family
            during a difficult time, proper planning can prevent this. Failing
            to plan for Estate Administration Costs can place a financial burden
            on your loved ones.
          </p>
        </div>

        <div class="calculate-actions">
          <div class="action-left">
            <GradientButton
              :title="'Calculate My Costs'"
              :small="true"
              :callout="'right'"
              @gradientButtonClicked="
                $router.push('estimated-insurance-required-input')
              "
            />
          </div>
          <div class="action-right"></div>
        </div>
        <div class="separator"></div>

        <div class="header-with-title-section">
          <h1>Estate Administration Costs</h1>
          <h3>
            Costs will be incurred to wrap up your estate.  These will be
            related to unavoidable estate administration service fees as well as
            duties and taxes.
            <span
              >An estimate of these costs for estates of different sizes is
              shown below.</span
            >
          </h3>
        </div>

        <div class="breakdown-section">
          <div class="title-section">
            <h3>Estimated Estate Administration Costs</h3>
          </div>
          <div class="content-section">
            <div class="content">
              <h3>R 500 000 estate</h3>
              <p>R 50 805</p>
            </div>
            <div class="content">
              <h3>R 1.5 million estate</h3>
              <p>R 109 728</p>
            </div>
            <div class="content">
              <h3>R 3 million estate</h3>
              <p>R 191 961</p>
            </div>
          </div>
        </div>
        <div class="impact-title-section">
          <h1>The Impact on Your Loved Ones</h1>
          <p>
            Failing to plan for Estate Administration Costs can place a
            financial burden on your loved ones.
          </p>
        </div>
        <div class="impact-on-loved-ones-section">
          <div class="impact">
            <v-img
              :src="
                require(`@/assets/${whitelabel.images.financialStrainIcon}`)
              "
              alt="Financial strain"
              title="Financial strain"
            />
            <h3>Immediate Financial Strain</h3>
            <p>Lack of funds to cover estate costs.</p>
          </div>
          <div class="impact">
            <v-img
              :src="require(`@/assets/${whitelabel.images.propertySaleIcon}`)"
              alt="Financial strain"
              title="Financial strain"
            />
            <h3>Forced Property Sale</h3>
            <p>Potential forced sale of family assets.</p>
          </div>
          <div class="impact">
            <v-img
              :src="require(`@/assets/${whitelabel.images.delayedSupportIcon}`)"
              alt="Financial strain"
              title="Financial strain"
            />
            <h3>Delayed Support</h3>
            <p>Financial uncertainty during estate settlement.</p>
          </div>
        </div>
        <div class="loved-ones-separator"></div>

        <div class="how-can-we-help-section">
          <div class="section-title">
            <h1>How We Can Help</h1>
          </div>
          <div class="section-content">
            <div class="left">
              <span class="colored-title"
                ><span>Estate</span><span>Assist</span></span
              >
              <div class="description-section">
                <p class="large">
                  Our <span>optional range of EstateAssist products</span> helps
                  to manage these costs, ensuring your loved ones aren't
                  unnecessarily burdened
                </p>
                <p class="small">
                  With EstateAssist, we cover legal costs and offer additional
                  optional benefits for daily living expenses, education
                  provision, and debt protection
                </p>
              </div>
            </div>
            <div class="right">
              <div class="right-description-container">
                <h3>In the next steps, we’ll provide you with:</h3>
                <div class="description-container-item">
                  <div class="item-container">
                    <div class="left-item">
                      <v-img
                        :src="
                          require(`@/assets/${whitelabel.images.customizedCostCalculation}`)
                        "
                        alt="Customized cost calculation"
                        title="Customized cost calculation"
                      />
                    </div>
                    <div class="right-item">
                      <h1>Customised Cost Calculation:</h1>
                      <p>
                        We will provide you with a detailed cost estimation to
                        outline the expenses involved in winding up your estate.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="description-container-item">
                  <div class="item-container">
                    <div class="left-item">
                      <v-img
                        :src="
                          require(`@/assets/${whitelabel.images.personalRecommendation}`)
                        "
                        alt="Personal recommendation"
                        title="Personal recommendation"
                      />
                    </div>
                    <div class="right-item">
                      <h1>Personal Recommendation:</h1>
                      <p>
                        You will receive a tailored recommendation about how you
                        can protect your family against these costs.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="loved-ones-separator"></div>

        <div class="take-action-section">
          <div class="action-left">
            <div class="action-left-content">
              <p>
                <span>Take action now.</span> Protect your loved ones from
                unforeseen costs. <span>Secure their future</span> and ensure
                your legacy of care and provision.
              </p>
            </div>
          </div>
          <div class="action-right">
            <GradientButton
              :title="'Calculate My Costs'"
              :small="true"
              :callout="'right'"
              @gradientButtonClicked="
                $router.push('estimated-insurance-required-input')
              "
            />
          </div>
        </div>
        <div class="loved-ones-separator"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'InsuranceExplanation',
    props: {
      buttonLoading: {
        default: false,
        type: Boolean,
      },
      testator: {
        required: true,
        type: Object,
      },
    },
    computed: {
      fullInsuranceEnabled() {
        return this.testator.enabledFeatures.includes('full_insurance');
      },
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .insurance-explanation-container {
    margin-top: 5px;

    .title-text {
      font-size: 32px;
      font-weight: 700;
      line-height: 36px;
      color: #282828;
      margin: 0;
    }
    .header-with-paragraph {
      margin-top: 47px;
      h3 {
        font-size: 16px;
        font-weight: 600;
        line-height: 26px;
        color: #282828;
      }
      p {
        margin: 0;
        margin-top: 4px;
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;
      }
    }
    .header-with-title-section {
      margin-top: 40px;
      h1 {
        font-size: 24px;
        font-weight: 600;
        line-height: 31.2px;
      }
      h3 {
        margin-top: 16px;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;

        span {
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
        }
      }
      p {
        margin: 0;
        margin-top: 4px;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      }
    }
    .breakdown-section {
      margin-top: 20px;
      box-shadow: 0px 28px 34px 0px #00000024;

      padding-top: 30px;
      padding-bottom: 30px;
      padding-left: 40px;
      padding-right: 40px;

      .title-section {
        h3 {
          font-size: 20px;
          font-weight: 600;
          line-height: 18px;
          color: #282828;
        }
      }
      .content-section {
        margin-top: 16px;
        width: 100%;
        display: flex;
        gap: 24px;

        .content {
          flex: 1;
          height: 56px;
          border-left: 3px solid #ed0080;
          background-color: #f2f2f2;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 10px;
          padding-right: 10px;

          h3 {
            color: #282828;
            font-size: 16px;
            font-weight: 600;
            line-height: 18px;
          }
          p {
            margin: 0;
            color: #ed0080;
            font-size: 16px;
            font-weight: 600;
            line-height: 22px;
            text-wrap: nowrap;
          }
        }
      }
    }

    .impact-title-section {
      margin-top: 40px;
      h1 {
        font-size: 24px;
        font-weight: 600;
        line-height: 31.2px;
        color: #282828;
      }
      p {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        color: #282828;
        margin-top: 16px;
      }
    }
    .impact-on-loved-ones-section {
      display: flex;
      justify-content: space-between;
      margin-top: 18px;

      .impact {
        padding-left: 8px;
        padding-right: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        .v-image {
          max-height: 96px;
        }

        h3 {
          margin-top: 8px;
          font-size: 16px;
          font-weight: 600;
          line-height: 20px;
          letter-spacing: 0.0015em;
          color: #282828;
          text-align: center;
        }
        p {
          margin: 0;
          margin-top: 8px;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          color: #282828;
          text-align: center;
        }
      }
    }

    .loved-ones-separator {
      margin-top: 30px;
      border: 1px solid #dfe2e5;
    }

    .how-can-we-help-section {
      width: 100%;
      margin-top: 40px;

      .section-title {
        h1 {
          font-size: 24px;
          font-weight: 600;
          line-height: 31.2px;
          color: #282828;
        }
      }
      .section-content {
        margin-top: 20px;
        box-shadow: 0px 28px 34px 0px #00000024;
        padding: 40px;
        display: flex;
        gap: 60px;
        .left {
          flex: 1;

          .colored-title {
            text-wrap: nowrap;
            span:first-of-type {
              color: #ed0080;
              font-size: 24px;
              font-weight: 700;
              line-height: 36px;
              text-wrap: nowrap;
              text-decoration: underline;
            }

            span:last-of-type {
              color: #000000;
              font-size: 24px;
              font-weight: 500;
              line-height: 36px;
              text-wrap: nowrap;
              text-decoration: none !important;
            }
          }

          .description-section {
            margin-top: 24px;
            p.large {
              margin: 0;
              font-size: 20px;
              font-weight: 400;
              line-height: 28px;
              color: #282828;

              span {
                font-size: 20px;
                font-weight: 600;
                line-height: 28px;
                color: #000000;
              }
            }
            p.small {
              margin: 0;
              margin-top: 20px;
              font-size: 16px;
              font-weight: 400;
              line-height: 24px;
            }
          }
        }

        .right {
          flex: 1;

          .right-description-container {
            width: 100%;
            margin-top: 61px;

            h3 {
              color: #282828;
              font-size: 16px;
              font-weight: 600;
              line-height: 24px;
            }
            .description-container-item {
              margin-top: 20px;

              .item-container {
                display: flex;
                .left-item {
                  padding-right: 24px;
                }
                .right-item {
                  flex: 1;

                  h1 {
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                    color: #282828;
                  }
                  p {
                    margin: 0;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 24px;
                    color: #282828;
                  }
                }
              }
            }
          }
        }
      }
    }

    .take-action-section {
      margin-top: 40px;
      display: flex;
      align-items: center;
      .action-left {
        flex: 1;

        .action-left-content {
          max-width: 627px;
        }

        p {
          margin: 0;
          font-size: 20px;
          font-weight: 400;
          line-height: 28px;
          color: #282828;

          span {
            font-size: 20px;
            font-weight: 600;
            line-height: 28px;
          }
        }
      }
    }
  }

  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .insurance-explanation-container {
      .breakdown-section {
        padding-left: 24px;
        padding-right: 24px;

        .content-section {
          flex-direction: column;
          .content {
            min-height: 56px;
          }
        }
      }
    }
  }

  @media only screen and (min-width: 0px) and (max-width: 599px) {
    .insurance-explanation-container {
      .breakdown-section {
        .title-section {
          h3 {
            line-height: 24px;
          }
        }
      }
      .header-with-paragraph {
        margin-top: 20px;
        p {
          margin-top: 12px;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          text-align: left;
        }

        h3 {
          line-height: 24px;
        }
      }

      .header-with-title-section {
        h1 {
          line-height: 24px;
        }
        p {
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
        }
      }
      .impact-title-section {
        margin-top: 30px;
        p {
          line-height: 24px;
        }
      }
      .impact-on-loved-ones-section {
        margin-top: 16px;
        flex-direction: column;

        .impact {
          margin-top: 16px;
        }
      }
      .how-can-we-help-section {
        margin-top: 30px;

        .section-content {
          gap: 10px;
          margin-top: 16px;
          padding-left: 24px;
          padding-right: 24px;
          padding-top: 30px;
          padding-bottom: 30px;
          flex-direction: column;

          .right {
            .right-description-container {
              margin-top: 10px;
            }
          }
        }
      }

      .take-action-section {
        margin-top: 30px;
        flex-direction: column;

        .action-right {
          margin-top: 30px;
        }
      }
    }
  }
  .separator {
    margin-top: 40px;
    border: 1px solid #dfe2e5;
  }

  .calculate-actions {
    display: flex;
    margin-top: 30px;
  }
</style>
